import React from "react";
import "./SmsOptInPage.css";

const SmsOptInPage: React.FC = () => {
  return (
    <div className="sms-optin-page">
      <div className="sms-optin-container">
        <div className="sms-optin-header">
          <span className="sms-optin-logo-box">
            <img src="/r.png" alt="Requesta" className="sms-optin-logo-img" />
          </span>
          <span className="sms-optin-logo-text">REQUEST APP</span>
        </div>

        <div className="sms-optin-card">
          <h2>SMS Notification Consent</h2>
          <p className="sms-optin-description">
            When artists sign up for Requesta, they have the option to enable SMS notifications
            to receive alerts when fans submit song requests. Below is the exact opt-in
            experience shown to users.
          </p>

          <div className="sms-optin-preview">
            <h3>Add SMS Notifications</h3>
            <p className="preview-text">
              Add your phone number to receive SMS notifications when someone sends you a song request.
            </p>
            <p className="preview-subtext">
              We'll only text you about incoming requests — no ads, no spam.
            </p>

            <div className="preview-phone-input">
              <select className="preview-country-select" disabled>
                <option>🇺🇸 +1</option>
              </select>
              <input
                type="tel"
                placeholder="Phone number"
                className="preview-phone-field"
                disabled
              />
            </div>

            <div className="preview-consent-checkbox">
              <input type="checkbox" id="sms-consent" checked readOnly />
              <label htmlFor="sms-consent">
                Activate SMS notifications
              </label>
            </div>

            <div className="preview-buttons">
              <button className="preview-btn-secondary" disabled>Add Later</button>
              <button className="preview-btn-primary" disabled>Enable Notifications</button>
            </div>
          </div>

          <div className="sms-optin-legal">
            <h4>Consent Language & Terms</h4>
            <ul>
              <li>SMS notifications are <strong>optional</strong> and not required to use Requesta</li>
              <li>Users must explicitly check the "Activate SMS notifications" checkbox to opt-in</li>
              <li>Messages are only sent for incoming song requests — no marketing or promotional content</li>
              <li>Users can disable SMS notifications at any time from their profile settings</li>
              <li>Standard message and data rates may apply</li>
              <li>Message frequency varies based on song request volume</li>
            </ul>
          </div>

          <div className="sms-optin-contact">
            <h4>Contact Information</h4>
            <p>
              For questions about SMS notifications or to opt-out, users can:
            </p>
            <ul>
              <li>Disable notifications in their profile settings</li>
              <li>Reply STOP to any SMS message</li>
              <li>Contact support at support@requesta.app</li>
            </ul>
          </div>
        </div>

        <div className="sms-optin-footer">
          <p>This page is provided for compliance verification purposes.</p>
          <p>&copy; {new Date().getFullYear()} Requesta. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default SmsOptInPage;
